<template>
    <div>
        <form @submit.prevent>
            <base-input v-model="selectedTranslation.title" label="Title" placeholder="New translation"
                :disabled="disabled" />
            <base-input :value="formatLanguages(selectedTranslation.languages)" label="Languages"
                :disabled="disabled" />

            <div v-if="selectedTranslation.files.support.length > 0" class="mb-sm">
                <label class="base-input__label">Support materials</label>
                <TranslationFileView v-for="file in selectedTranslation.files.support" :key="file.url"
                    :translationFile="file" />
            </div>

            <div v-if="selectedTranslation.files.toBeTranslated.length > 0" class="mb-sm">
                <label class="base-input__label">Files to be translated</label>
                <TranslationFileView v-for="file in selectedTranslation.files.toBeTranslated" :key="file.url"
                    :translationFile="file" />
            </div>

            <base-textarea v-model="selectedTranslation.notes.byClient" label="Notes" :disabled="disabled"
                :setStyle="{ minHeight: '85px' }" />

            <div>
                <label class="base-input__label">Deadline</label>
                <el-date-picker class="el-date-padding-order" placeholder="No set deadline"
                    v-model="selectedTranslation.timestamps.deadline" type="date" :disabled="disabled" />
            </div>

            <FolderSelect @change="form.folder_id = $event" class="mt-3" :disabled="disabled" />

        </form>
    </div>
</template>

<script>
import { Table, TableColumn, DatePicker } from "element-ui";
import { BaseInput, BaseTextarea } from "@/components"
import TranslationFileView from "./TranslationFileView.vue";
import FolderSelect from "src/pages/Tools/ToolsComponent/FolderSelect.vue";

import Translation from '../Entities/Translation';

import { formatLanguages } from "../Helpers/formatters";

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        BaseInput,
        BaseTextarea,
        [DatePicker.name]: DatePicker,
        TranslationFileView,
        FolderSelect,
    },
    props: {
        translation: {
            type: Translation,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            form: {
                folder_id: "",
            },
            /** @type Translation|null */
            selectedTranslation: null,
        }
    },
    beforeMount() {
        this.selectedTranslation = this.translation
    },
    methods: {
        formatLanguages,
    }
}
</script>
